import { render } from "./loading.vue?vue&type=template&id=0b70c818"
import script from "./loading.vue?vue&type=script&lang=js"
export * from "./loading.vue?vue&type=script&lang=js"

import "./loading.vue?vue&type=style&index=0&id=0b70c818&lang=scss"

import exportComponent from "D:\\project\\gis_map\\xq_demo\\xq_demo_front\\xq_demo_admin_site_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__